import React from 'react';
import styles from './ThreeCardBlock.module.scss';
import {
  ImageCardFragment,
  ThreeCardBlockFragment
} from '@src/graphql/gql-types';
import ImageCard from '../ImageCard';
import { Container } from '@src/elements/Grid';
import Heading from '@src/elements/Heading';
import { COLOR_SIDECAR_LIGHTER } from '@src/types/colors';

type ThreeCardBlock = ThreeCardBlockFragment;

const ThreeCardBlock: React.FC<ThreeCardBlock> = ({
  tagline,
  heading,
  description,
  cardsCollection
}) => {
  return (
    <div className={styles.threeCardBlock}>
      <Container>
        <div className={styles.tagline}>{tagline}</div>
        <Heading priority={2} fontStyle="h1">
          {heading}
        </Heading>
        <p className={styles.description}>{description}</p>
        <div className={styles.cards}>
          {cardsCollection?.items.map((card, index) => (
            <ImageCard
              key={`${card?.sys.id}-${index}`}
              {...(card as ImageCardFragment)}
              background={COLOR_SIDECAR_LIGHTER}
              fill
              collapsibleDescription
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ThreeCardBlock;
